export const update = {
  form: {
    method: 'Method',
    detergentUsed: 'Detergent Used',
    name: 'Method Name',
    washingTime: 'Washing Time',
    companyName: 'Company Name',
    detergentName: 'Detergent Name',
    quantity: 'Quantity',
    unit: 'Units',
    addNew: 'Add New',
    requireName: 'Please input washing method',
    requireWashingTime: 'Please input washing time',
    requireCompanyName: 'Please input company name',
    requireDetergentName: 'Please input detergent name',
    requireQuantity: 'Please input quantity',
    requireUnit: 'Please input unit',
    save: 'Save',
    cancel: 'Cancel',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Edit Method Information',
    back: 'Back',
  },
}
